import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';

import styled from '@emotion/styled';

import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import {
  DRIVER_INFORMATION,
  USER_MANAGEMENT,
} from '../../../routes/routeConstants';
import DrivePerformanceChart from './DrivePerformanceChart';
import DriverBioArea from './DriverBioArea';
import FeedbackDistribution from './FeedbackDistribution';
import IncidentDistribution from './IncidentDistribution';
import StatsCard from './StatsCard';

const DriverPerformanceInformation = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);
  const {
    companyId,
    companyName,
    // driverId,
    jsonData,
  } = useParams();
  const { pathname } = useLocation();

  const objectFyData = jsonData
    ? JSON.parse(decodeURIComponent(jsonData ?? ''))
    : null;

  useEffect(() => {
    setPathArr(() => [
      {
        name: `User Management`,
        link: `/${USER_MANAGEMENT}`,
      },
      {
        name: `${companyName} - Driver List`,
        link: `/${DRIVER_INFORMATION}/${companyId}/${companyName}`,
      },
      {
        name: `${objectFyData?.firstName} ${objectFyData?.lastName} - Driver Performance`,
        link: pathname,
      },
    ]);
    // eslint-disable-next-line
  }, []);
  return (
    <Page title='Logirate | Driver Performance'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <HeaderArea>
            <DriverBioArea />
          </HeaderArea>
          <StatsCard />
          <DrivePerformanceChart />
          <IncidentDistribution />
          <FeedbackDistribution />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverPerformanceInformation;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const HeaderArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 28px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
`;
